import { defineStore } from "pinia";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    isAuthenticated: false,
    user: {
      usuario: {
        titulo: "",
      },
      config: {
        componente: "default",
      },
      token: "",
    },
    tokenRecover: {
      email: null,
      token: null,
      tokenValue: null,
    },
  }),

  actions: {
    setTotkenRecoverStore(v) {
      console.log("first");
      this.tokenRecover["email"] = v.email ?? this.tokenRecover["email"];
      this.tokenRecover["token"] = v.token ?? this.tokenRecover["token"];
      this.tokenRecover["tokenValue"] = v.tokenValue ?? this.tokenRecover["tokenValue"];
    },
    setUser(v) {
      (this.isAuthenticated = true), (this.user = v);
    },
    setNomeUser(v) {
      this.user.usuario.titulo = v;
    },
    setLogoff() {
      (this.isAuthenticated = false), (this.user = { usuario: { titulo: "" } });
    },
    setUserToken(v) {
      this.user.token = v
    },
  },
  persist: true,
});
